export default __webpack_public_path__ + "static/track-example-gif-54d9a008484b5afd51fd1f5818abb21e.mp4";